import React, { useCallback } from 'react';
import PageLayout from 'layout/page';
import styles from 'feature/profile-setting/index.module.scss';
import Button from 'components/button';
import { useProfileSetting, CHANGE_EMAIL, CHANGE_DISPLAY_NAME } from 'feature/profile-setting/use-profile-setting';
import FormInput from 'components/form-input';
import { useAppContext } from 'use-app';
import Checkbox from 'components/checkbox';
import { Content } from 'components/marketing-email-optedin-dialog';

const ProfileSetting = () => {
  const { state: appState } = useAppContext();
  const { state, dispatch, updateProfile, onMarketingEmailOptedInChange } = useProfileSetting();

  // 改變mail
  const onEmailChanged = useCallback(
    email => {
      dispatch({
        type: CHANGE_EMAIL,
        payload: email,
      });
    },
    [dispatch]
  );

  // 改變名稱
  const onDisplayNameChanged = useCallback(
    displayName => {
      dispatch({
        type: CHANGE_DISPLAY_NAME,
        payload: displayName,
      });
    },
    [dispatch]
  );

  // 儲存
  const onSave = useCallback(() => {
    updateProfile(state.email, state.displayName, state.marketingEmailOptedIn);
  }, [state, updateProfile]);

  return (
    <PageLayout theme="form">
      <div className={styles['profile-setting']}>
        <div>
          <FormInput value={appState.me?.mobile} label="手機號碼" labelFor="mobile" disabled={true} />
          <div className={styles.notice}>為了確保您的帳號使用安全，如需更改手機號碼，請聯絡麻吉付客服協助修改。</div>
          <FormInput
            type="email"
            value={state.email}
            placeholder="輸入 Email 地址"
            label="電子信箱"
            labelFor="email"
            onTextChanged={onEmailChanged}
            errorMessage={state.emailErrorMessage}
          />
          <FormInput
            label="暱稱"
            labelFor="name"
            value={state.displayName}
            placeholder="輸入暱稱"
            onTextChanged={onDisplayNameChanged}
            errorMessage={state.displayNameErrorMessage}
          />
          <div className={styles.marketingEmail}>
            <Checkbox
              isChecked={state.marketingEmailOptedIn}
              onCheckChanged={() => {
                onMarketingEmailOptedInChange(!state.marketingEmailOptedIn);
              }}
            />
            <div>
              <Content />
            </div>
          </div>
        </div>
        <Button theme="default" loading={state.loading} block={true} onClick={onSave}>
          儲存
        </Button>
      </div>
    </PageLayout>
  );
};

export default ProfileSetting;
